import { render } from "./Replies.vue?vue&type=template&id=3d69df59"
import script from "./Replies.vue?vue&type=script&lang=js"
export * from "./Replies.vue?vue&type=script&lang=js"
script.render = render

export default script